import { Form, Formik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import Login from "./components/onboarding/Login";
import Register from "./components/onboarding/Register";
import ResetPassword from "./components/onboarding/ResetPassword";
import FormField from "./components/onboarding/utilComponents/FormField";
import Divider from "./components/shared/Divider";
import FormButton from "./components/shared/FormButton";
import FullModal from "./components/shared/FullModal";
import { forceResetPassword } from "./features/auth/actions/auth";
import * as Yup from "yup";
import { resetPassFields } from "./utils/utils";
import ErrorAlert from "./components/shared/ErrorAlert";
import { setAuthError } from "./features/auth/authSlice";
import AlertShared from "./components/shared/AlertShared";
import { setAlertDefault } from "./features/app/alert/alertSlice";
import License from "./components/onboarding/license";

const ResetPassSchema = Yup.object().shape({
  new_password: Yup.string()
    .min(8, "Password should be atleast 8 characters in length")
    .max(20, "Password should not exceed 20 characters")
    .required("This field is required"),
  confirm_password: Yup.string()
    .min(8, "Password should be atleast 8 characters in length")
    .max(20, "Password should not exceed 20 characters")
    .required("This field is required")
    .oneOf([Yup.ref("new_password"), null], "Passwords must match"),
});

const LoginApp = () => {
  const dispatch = useDispatch();

  const accountVerified = useSelector((state) => state.auth.accountVerified);
  const vendorUserId = useSelector((state) => state.auth.vendorUserId);

  const alertMsg = useSelector((state) => state.alert.alertMsg);
  const alertType = useSelector((state) => state.alert.alertType);

  React.useEffect(() => {
    if (alertMsg) {
      setTimeout(() => {
        dispatch(setAlertDefault(null));
      }, 7500);
    }
  }, [alertMsg]);

  return (
    <>
      {accountVerified === "VERIFICATION_REQUIRED" && (
        <FullModal>
          <div className="rounded-lg bg-white p-6 w-96">
            <div className="mb-8">
              <div className="font-bold text-lg">Reset Your Password</div>
              <div>Please enter a new password and confirm it.</div>
            </div>
            <Formik
              initialValues={{
                new_password: "",
                confirm_password: "",
              }}
              validationSchema={ResetPassSchema}
              onSubmit={(values) => {
                dispatch(
                  forceResetPassword({
                    value: values.new_password,
                    vendorUserId,
                  })
                );
              }}
            >
              {({ isSubmitting }) => (
                <Form>
                  {resetPassFields
                    .filter((passField) => passField.name !== "recoveryCode")
                    .map((field) => (
                      <FormField key={field.name} {...field} />
                    ))}
                  <Divider />
                  <FormButton
                    isSubmitting={isSubmitting}
                    buttonText="Reset Password"
                  />
                </Form>
              )}
            </Formik>
          </div>
        </FullModal>
      )}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/license" element={<License />} />
      </Routes>
      {alertMsg && <AlertShared alertMsg={alertMsg} severity={alertType} />}
    </>
  );
};

export default LoginApp;
